import { ServiceProviderForm } from "../ServiceProviderForm";

export const AddServiceProvider = () => {
  return <ServiceProviderForm />;
};
